import _ from "lodash";
import { removeNonDigits } from "./stringUtils";

export const isValidZipCode = (zip: string): boolean =>
  _.size(removeNonDigits(zip)) === 9 || _.size(removeNonDigits(zip)) === 5;
